import { render, staticRenderFns } from "./UploadAmendmentsForm.vue?vue&type=template&id=cd6f8d2a"
import script from "./UploadAmendmentsForm.vue?vue&type=script&lang=js"
export * from "./UploadAmendmentsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports